import { useTranslation } from 'react-i18next'

import { LogOut } from 'lucide-react'

import { hasRole } from '@/lib/roles'

import { useAuthStore } from '@/stores/auth'

import { BranchSwitcher } from '@/layouts/components/BranchSwitcher'
import { NavMain } from '@/layouts/dashboard/components/NavMain'
import { NavUser } from '@/layouts/dashboard/components/NavUser'

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from '@/components/ui/sidebar'

import { useNavRegistry } from '@/nav/navRegistry'

import { SidebarLogo } from '../components/SidebarLogo'

export default function DashboardSidebar() {
  const { i18n, t } = useTranslation(['common', 'dashboard'])
  const { logout } = useAuthStore()
  const user = useAuthStore((state) => state.user)

  const role = user?.roles?.[0] ?? 'guest'
  const navItems = useNavRegistry(role)
  const rtlSidebar = i18n.dir() === 'rtl' ? 'right' : 'left'

  return (
    <Sidebar collapsible='icon' side={rtlSidebar}>
      <SidebarHeader>{hasRole(user, 'super_admin') ? <BranchSwitcher /> : <SidebarLogo />}</SidebarHeader>
      <SidebarContent className='scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-200'>
        <NavMain items={navItems} />
      </SidebarContent>
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              className='cursor-pointer'
              onClick={async (e: React.SyntheticEvent) => {
                e.preventDefault()
                await logout()
              }}
            >
              <LogOut className='text-muted-foreground' aria-hidden='true' />
              <span>{t('userDropdown.menu.logOut', { ns: 'common', defaultValue: 'Log Out' })}</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
